import { render, staticRenderFns } from "./PDPCommentStatusTag.vue?vue&type=template&id=0e7e8c6a&scoped=true&"
import script from "./PDPCommentStatusTag.vue?vue&type=script&lang=js&"
export * from "./PDPCommentStatusTag.vue?vue&type=script&lang=js&"
import style0 from "./PDPCommentStatusTag.vue?vue&type=style&index=0&id=0e7e8c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e7e8c6a",
  null
  
)

export default component.exports